// StatCard molecule component
import { Heading, Text } from "../atoms";
import { Card } from "./Card";

export const StatCard = ({ icon, value, label }) => {
  return (
    <Card hoverable className="p-8 text-center">
      {icon && <div className="text-3xl mb-2">{icon}</div>}
      <Heading level={2} className="text-terracotta-600 mb-3">
        {value}+
      </Heading>
      <Text size="lg" className="text-ink-soft">
        {label}
      </Text>
    </Card>
  );
};
